<template>
	<router-view/>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

//import QuickLinks from '@/components/QuickLinks';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'TankOn2'});
	},
	data: () => ({
		
	}),
	computed: {},
	methods: {
		redirectToAuth(){
			const redirectUri = window.location.origin;
			const authUrl = 'https://id.bylex.su/login-out?' + new URLSearchParams({
				redirect: redirectUri,
			});
			window.location.href = authUrl;
		},
	},
	created(){
		this.$http.interceptors.response.use(undefined, function(err){
			return new Promise(function(resolve, reject){
				if(err.status === 401 && err.config && !err.config.__isRetryRequest){
					this.authModel.doLogout();
				}
				throw err;
			});
		});
	},
	components: {
		//QuickLinks,
	},
}
</script>
